/** Origen público del dashboard (Better Auth valida `redirectTo` frente a esto). */
export function getDashboardOrigin(): string {
  const v = import.meta.env.VITE_APP_URL;
  if (typeof v === "string" && v.trim().length > 0) {
    return v.replace(/\/+$/, "");
  }
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return "http://localhost:5173";
}

/** Base HTTP de la API Nest (sin barra final). */
export function getApiBaseUrl(): string {
  const v = import.meta.env.VITE_API_URL;
  const raw = typeof v === "string" && v.trim().length > 0 ? v : "http://localhost:3001";
  return raw.replace(/\/+$/, "");
}

/**
 * El botón «Continuar con Google» se muestra por defecto.
 * Solo se oculta si defines explícitamente `VITE_GOOGLE_AUTH_ENABLED=false` (p. ej. entorno sin OAuth).
 * Las claves `GOOGLE_CLIENT_ID` / `GOOGLE_CLIENT_SECRET` solo las lee la API; no hace falta duplicarlas como `VITE_*`.
 */
export function isGoogleAuthEnabled(): boolean {
  return import.meta.env.VITE_GOOGLE_AUTH_ENABLED !== "false";
}

/**
 * El botón «Continuar con Apple» se muestra por defecto.
 * Solo se oculta si defines explícitamente `VITE_APPLE_AUTH_ENABLED=false`.
 */
export function isAppleAuthEnabled(): boolean {
  return import.meta.env.VITE_APPLE_AUTH_ENABLED !== "false";
}

/**
 * El acceso con passkey se muestra por defecto si está soportado.
 * Se puede desactivar con `VITE_PASSKEY_AUTH_ENABLED=false`.
 */
export function isPasskeyAuthEnabled(): boolean {
  return import.meta.env.VITE_PASSKEY_AUTH_ENABLED !== "false";
}

/**
 * URL absoluta tras OAuth (`callbackURL` de Better Auth).
 * Debe coincidir con orígenes de confianza (p. ej. `CORS_ORIGIN` / `VITE_APP_URL`).
 */
export function buildOAuthCallbackUrl(pathname: string): string {
  const origin = getDashboardOrigin();
  const path = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return `${origin}${path.length > 0 ? path : "/"}`;
}
